import { render, staticRenderFns } from "./AIChatWidgetDropdown.vue?vue&type=template&id=7b496c32&scoped=true"
import script from "./AIChatWidgetDropdown.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetDropdown.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetDropdown.vue?vue&type=style&index=0&id=7b496c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b496c32",
  null
  
)

export default component.exports